import clsx from "clsx";
import { FC, useMemo } from "react";

import { isNullOrEmptySpace, NO_VALUE_DISPLAY } from "@ryde/shared";

import { FramerTooltip } from "../../common";
import { useDecorateWithMark } from "../../utils";

interface ITextCellTemplateReports {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
  name: string;
  isHiddenFromView?: boolean;
  className?: string;
}

export const TextCellTemplateReports: FC<ITextCellTemplateReports> = ({
  value,
  name,
  isHiddenFromView,
  className,
}) => {
  const { decorateValue } = useDecorateWithMark();

  const highlightedValue = useMemo(() => {
    return decorateValue(String(value || ""));
  }, [value, decorateValue]);

  const tooltipContent = useMemo(() => {
    return !isNullOrEmptySpace(value) ? value : NO_VALUE_DISPLAY;
  }, [value]);

  return (
    <div
      className={clsx("cell_simple", className, {
        is_hidden: isHiddenFromView,
      })}
      data-e2e-id={`${name}`}
      data-e2e-value={value}
      data-e2e-template="text-cell-report"
    >
      <FramerTooltip content={tooltipContent} rtlStrippedBottomLeftPlacement>
        <span>{highlightedValue}</span>
      </FramerTooltip>
    </div>
  );
};
